import { render, staticRenderFns } from "./ForexCurrencyPairEditorModal.vue?vue&type=template&id=b34b409e"
import script from "./ForexCurrencyPairEditorModal.vue?vue&type=script&lang=js"
export * from "./ForexCurrencyPairEditorModal.vue?vue&type=script&lang=js"
import style0 from "./ForexCurrencyPairEditorModal.vue?vue&type=style&index=0&id=b34b409e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports